module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-02.dad90182.jpg";